import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanCreate from "UnitPlans/routes/UnitPlanCreate";
import YearlyInsight from "YearlyInsight";
import CourseUnitPlansOverview from "UnitPlans/routes/CourseUnitPlansOverview";
import CourseUnitPlansTimelineTable from "UnitPlans/routes/CourseUnitPlansTimelineTable";
import CardView from "UnitPlans/routes/CardView";
import CourseFlow from "LearningCourse/routes/CourseFlow";
import UnitPlanDetails from "UnitPlans/routes/UnitPlanDetails";
import TimetablePlanner from "./routes/TimetablePlanner";

export default store => ({
  path: "course-plan",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-plan" */ "./components"),
      import(
        /* webpackChunkName: "unitPlans" */ "IBPlanner/modules/IBPlannerModule"
      ),
      import(
        /* webpackChunkName: "unitPlans" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
      ),
      import(
        /* webpackChunkName: "unitPlans" */ "SubjectsSetup/modules/SubjectsModule"
      ),
      import(
        /* webpackChunkName: "unitPlans" */ "Scheduler/modules/SchedulerModule"
      ),
      import(
        /* webpackChunkName: "unitPlans" */ "UnitPlans/routes/NewCourseUnitPlansOverviewV2/modules/Module"
      ),
      import(
        /* webpackChunkName: "course-flow" */ "CourseFlow/modules/CourseFlowModule"
      ),
      import(
        /* webpackChunkName: "course-plan" */ "./modules/CoursePlanModule"
      ),
    ]).then(
      ([
        importedModule0,
        importedModule1,
        importedModule2,
        importedModule3,
        importedModule4,
        importedModule5,
        importedModule6,
        importedModule7,
      ]) => {
        const component = importedModule0.default;
        const plannerReducer = importedModule1.default;
        const multiLevelNodeEditorReducer = importedModule2;
        const subjectSetupReducer = importedModule3.default;
        const schedulerReducer = importedModule4.default;
        const courseUnitPlansOverviewReducer = importedModule5.default;
        const courseFlowReducer = importedModule6.default;
        const coursePlanReducer = importedModule7.default;

        injectReducer(store, {
          key: "planner",
          reducer: plannerReducer,
        });
        injectReducer(store, {
          key: "courseOverview",
          reducer: courseUnitPlansOverviewReducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer: multiLevelNodeEditorReducer.default,
        });
        injectReducer(store, {
          key: "subjectsSetup",
          reducer: subjectSetupReducer,
        });
        injectReducer(store, {
          key: "scheduler",
          reducer: schedulerReducer,
        });
        injectReducer(store, {
          key: "courseFlow",
          reducer: courseFlowReducer,
        });
        injectReducer(store, {
          key: "coursePlan",
          reducer: coursePlanReducer,
        });

        return component;
      }
    )
  ),
  childRoutes: [
    // Unit view child routes
    CourseUnitPlansOverview(store, "table"),
    CourseUnitPlansTimelineTable(store, "timeline"),
    CardView(store, "card"),
    UnitPlanCreate(store),
    YearlyInsight(store),
    // TimetablePlanner child route
    TimetablePlanner(store),
    // CourseFlow child routes
    CourseFlow(store, "flow"),
    // ALWAYS KEEP THIS AT THE END FOR DYNAMIC ROUTING TO WORK
    UnitPlanDetails(store),
  ],
});
